import React from 'react';
import { View } from 'react-native';
import { Gender, StrengthRatioForMuscleGroups } from '../../../models/src';
import { SelectionContainer } from '../Bookings/components/SelectionContainer';
import Theme, { ThemeType } from '../theme';
import { defaultScale } from '../utils/scaling';
import { getStrengthLevels } from '../utils/strengthLevels';
import { sharedStyles } from './OnboardingSharedStyles';

interface IProps {
  gender: Gender;
  levelSelectionCb(strengthRatios: StrengthRatioForMuscleGroups): void;
}

interface IState {
  level?: string;
}

export class StrengthLevel extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  public setLevelAndContinue = (
    level: string,
    strengthRatios: StrengthRatioForMuscleGroups,
  ) => {
    this.setState({ level });
    this.props.levelSelectionCb(strengthRatios);
  }

  public render() {
    const { gender } = this.props;
    const { level } = this.state;

    return (
      <View style={{ flex: 1, marginTop: defaultScale(24) }}>
        {getStrengthLevels(gender).map((strengthLevel) => {
          return (
            <SelectionContainer
              title={strengthLevel.display}
              overrideLightStyles={{
                defaultSubtitleColor: Theme.GREY_MEDIUM,
              }}
              subTitle={strengthLevel.subtitle}
              style={sharedStyles.selectionContainer}
              titleStyle={sharedStyles.bookingSelectionTitle}
              subTitleStyle={sharedStyles.bookingSelectionSubtitle}
              isSelected={level === strengthLevel.display}
              theme={ThemeType.light}
              onPress={() =>
                this.setLevelAndContinue(
                  strengthLevel.display,
                  strengthLevel.value,
                )
              }
              height={defaultScale(100)}
              width={'100%'}
            />
          );
        })}
      </View>
    );
  }
}
